<template>
  <div>
    <vue-headful
    :title="propsdata[0]['translation']['api-head-title']"
    :description="propsdata[0]['translation']['api-head-description']"
/>

    <div v-if="loading" style="margin-top: 150px;">
      <lottie-player src="https://qr.io/lottie/qr-loading.json" background="transparent" speed="1" style="width: 230px; height: 230px; margin: 0 auto;" loop autoplay></lottie-player>
    </div>

    <div v-if="!loading" class="container mb-3">
      <div class="card border-light shadow-soft rounded-top-0 rounded-bottom">
        <div class="card-body p-4">
          <div>
            <div v-if="propsdata[0].paid === 'yes'" class="col-12 p-0">
              <div v-if="propsdata[0].access_limit !== 'limited'" class="form-group">
                <label class="form-label text-dark">{{propsdata[0]['translation']['api-key']}}</label>
                <div class="input-group mb-2">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fas fa-bezier-curve"></i></span>
                  </div>
                  <input v-model="propsdata[0].apikey" name="name" class="form-control pl-2" :placeholder="propsdata[0]['translation']['api-input-placeholder']" type="text" disabled="disabled">
                </div>
                <button v-if="!generatingapikey && propsdata[0].access_limit !== 'limited'" @click="generateApikey" style="width: 100%;" class="btn btn-secondary animate-up-2">{{propsdata[0]['translation']['api-generate-new-key-button']}}</button>
                <button v-if="generatingapikey" style="width: 100%;background:#04a677!important;border-color:#04a677!important;" class="btn btn-secondary animate-up-2"><span class="mr-2"><i class="fas fa-check"></i></span>{{propsdata[0]['translation']['api-generating-new-key-button']}}</button>
                <h4 class="mt-4 mb-2">{{propsdata[0]['translation']['api-total-requests']}} {{apirequests}}</h4>
                <p class="mb-2" style="display:block;">{{propsdata[0]['translation']['api-requests-explanation']}}</p>
                <a href="https://qr.io/api-documentation" target="_blank" style="display:block;">{{propsdata[0]['translation']['api-get-started']}}</a>
              </div>
              <div v-if="propsdata[0].access_limit === 'limited'" class="alert alert-warning mb-0" role="alert">
                <span class="alert-inner--text">{{propsdata[0]['translation']['api-access-limit-warning']}}</span>
              </div>
            </div>
            <div v-else>
              <div class="col-12 p-0">
                <h4 class="mb-0">{{propsdata[0]['translation']['api-upgrade']}}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    props:['propsdata'],
    data() {
      return {
        loading: true,
        generatingapikey: '',
        apirequests: ''
      };
    },
    methods: {
      generateApikey(){
        this.generatingapikey = true;
        axios.post('/dashboard/generate-apikey.php', {
        })
        .then(response => {
          this.propsdata[0].apikey = response.data;
          this.generatingapikey = false;
        })
        .catch(function (error) {
          console.log(error);
        });
      },
      getApiRequests(){
        axios.post('/dashboard/api-requests.php', {
        })
        .then(response => {
          this.apirequests = response.data;
          this.loading = false;
        })
        .catch(function (error) {
          console.log(error);
        });
      }
    },
    mounted() {
      //API REQUESTS
      this.getApiRequests();
    }
  };
</script>



// WEBPACK FOOTER //
// src/api.vue